import { createComponent } from '@carvana/merch-components';

export const SectionWrapper = createComponent('section', {
  className: 'flex w-full flex-col gap-24 l:pb-40'
});

export const LinkSectionWrapper = createComponent('div', {
  className: 'flex w-full flex-col gap-24 px-24 py-28 l:px-[84px] l:py-40'
});

export const Title = createComponent('div', {
  className: 'text-blue-6 tl-header-m'
});

export const LinkGrid = createComponent('div', {
  className: 'grid grid-cols-1 gap-16 min-[480px]:grid-cols-2 m:grid-cols-3'
});

export const Link = createComponent('a', {
  className: 'text-grey-5 underline tl-link-m hover:text-blue-2'
});

export const ExpandButton = createComponent('div', {
  className: 'flex items-center gap-8 text-blue-2 tl-header-s'
});
